import { BaseModel } from '../../_base/crud';

export class Agreement extends BaseModel {
  id: number;
  name: string;
  type: string;
  status: string;
  signing_provider_id: string;
  signing_provider_name: string;
  signing_provider_document_id: string;
  date_sent: Date;
  date_signed: Date;
  start_date: Date;
  end_date: Date;
  void_date: Date;
  void_reason: string;
  last_reminder_date: string | Date;
  hours_since_last_reminder: number;
  url: string;

  clear() {
    this.id = 0;
    this.name = '';
    this.type = '';
    this.status = '';
    this.signing_provider_id = '';
    this.signing_provider_name = '';
    this.signing_provider_document_id = '';
    this.date_sent = undefined;
    this.date_signed = undefined;
    this.start_date = undefined;
    this.end_date = undefined;
    this.void_date = undefined;
    this.void_reason = '';
    this.last_reminder_date = '';
    this.hours_since_last_reminder = null;
    this.url = '';
  }

  static fromObject(agreementObj: Agreement) {
    return Object.assign(new Agreement(), agreementObj);
  }

  isLastReminderWithin24Hours(): boolean {
    if (this.hours_since_last_reminder == null) return false;

    return this.hours_since_last_reminder <= 24;
  }

  getHoursLeftForNextReminder(): number {
    if (this.hours_since_last_reminder === null) return 0;

    return 24 - this.hours_since_last_reminder;
  }
}
